import { z } from 'zod'

const orderLineSchema = z.object({
    id: z.number().or(z.string()),
    quantity: z.number().optional(),
    type: z.string(),
    price: z.number().optional(),
    code: z.string().or(z.number()).optional(),
    desc: z.string().optional(),
})

export const OrderSchema = z.object({
    id: z.string().optional(),
    email: z.string({ message: "Email is required" }).email(),
    firstName: z.string({ message: "First Name is required" }).refine((value) => value !== '', {
        message: "First Name is required",
    }),
    lastName: z.string().refine((value) => value !== '', {
        message: "Last Name is required",
    }),
    address: z.string().refine((value) => value !== '', {
        message: "Address is required",
    }),
    addressAddition: z.string().optional(),
    city: z.string().refine((value) => value !== '', {
        message: "City is required",
    }),
    country: z.string().refine((value) => value !== '', {
        message: "Country is required",
    }),
    state: z.string().refine((value) => value !== '', {
        message: "State is required",
    }),
    postalCode: z.string().refine((value) => value !== '', {
        message: "Postal code is required",
    }),
    phoneNumber: z.string().refine((value) => value !== '', {
        message: "Phone number is required",
    }),
    countryAbbr: z.string(),
    currency: z.string(),
    submitted: z.boolean().optional(),
    parcelID: z.string().optional(),
    orderLines: z.array(orderLineSchema),
    orderNumber: z.number().optional(),
    stripeReference: z.string().optional(),
    stripeTxID: z.string().optional(),
    currencyPrice: z.string().optional(),
})
